import React, {useEffect, useState} from 'react';
import {View} from 'react-native';

import {ScrollView} from 'react-native-gesture-handler';

import {useNavigation, useRoute} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';

import {makeStyles} from 'rne-netzon';
import {colorPalette} from '../../../core/config/color.config';

import {RNEButton, RNEText} from '../../components';

import useStores from '../../stores/useStores';

import {useGetHistoryConsultation} from '../../server/react-query/useConsultation';
import {
  ConsultationRequestResBody,
  ConsultationStatusEnum,
} from '../../server/types/consultation.types';

import ConsultationListItemHistory from '../consultation/ConsultationListItemHistory';

interface ConsultationHistoryTabProps {
  searchKey?: string;
}

const ConsultationHistoryTab = (props: ConsultationHistoryTabProps) => {
  const styles = useStyles();

  const route = useRoute();
  const navigation = useNavigation();

  const {patientProfileStore, recentlyViewedAccountsStore} = useStores();
  const activeProfile = patientProfileStore.activeProfileData;

  const [routeParams, setRouteParams] = useState({});

  const {data, isLoading} = useGetHistoryConsultation({
    status: props.searchKey
      ? [ConsultationStatusEnum.COMPLETED]
      : [ConsultationStatusEnum.COMPLETED, ConsultationStatusEnum.DECLINED],
    subject: activeProfile?.patientId,
    SortBy: 'modifiedOn',
    Ascending: false,
    searchKey: props.searchKey,
  });

  const onItemPressed = (
    id: string,
    consultationData: ConsultationRequestResBody,
  ) => {
    recentlyViewedAccountsStore.addRecentlyViewedAccount(id, consultationData);
    const params = {
      ...routeParams,
      id: id,
    };
    navigation.navigate(NavigationKey.CONSULTATION_DETAIL, params);
  };

  useEffect(() => {
    const params: any = route.params;

    if (params) {
      setRouteParams(params);
    }
  }, [route.params]);

  return (
    <ScrollView>
      {isLoading && (
        <View style={styles.spinnerContainer}>
          <RNEButton
            height={32}
            loadingProps={loadingPropsStyle}
            loading={isLoading}
          />
        </View>
      )}

      {data &&
        data.map((item, index) => (
          <ConsultationListItemHistory
            key={index}
            item={item}
            onPress={() => onItemPressed(item.serviceRequestId, item)}
          />
        ))}

      {data && data.length === 0 && (
        <View style={styles.placeholder}>
          <RNEText
            label={props.searchKey ? '' : 'No consultation history yet'}
            color="grey"
          />
        </View>
      )}
    </ScrollView>
  );
};

const loadingPropsStyle = {
  color: colorPalette.black,
};

const useStyles = makeStyles({
  spinnerContainer: {
    marginTop: 16,
    width: '100%',
    justifyContent: 'flex-end',
  },
  placeholder: {
    marginTop: 16,
    alignItems: 'center',
  },
});

export default ConsultationHistoryTab;
